import React from 'react';
import { Badge } from './ui/badge';
import { Calendar, CheckCircle2, Clock } from 'lucide-react';

/**
 * <CourseStateBadge course={course} /> — small status pill based on dates.
 * - finished: red, "Curso finalizado"
 * - upcoming: blue, "Próximamente · DD MMM"
 * - active: no pill (or green if `showActive`)
 */
const CourseStateBadge = ({ course, showActive = false, className = '' }) => {
  if (!course) return null;
  const state = course.course_state;
  const fmtDate = (d) => {
    if (!d) return '';
    try {
      const dt = new Date(`${d}T12:00:00`);
      return dt.toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' });
    } catch { return d; }
  };

  if (state === 'finished') {
    return (
      <Badge className={`bg-red-100 text-red-700 border border-red-200 gap-1 ${className}`} data-testid={`state-finished-${course.id}`}>
        <Clock className="w-3 h-3" />
        Curso finalizado
        {course.end_date && <span className="ml-1 text-[10px] opacity-80">· {fmtDate(course.end_date)}</span>}
      </Badge>
    );
  }
  if (state === 'upcoming') {
    return (
      <Badge className={`bg-blue-100 text-blue-700 border border-blue-200 gap-1 ${className}`} data-testid={`state-upcoming-${course.id}`}>
        <Calendar className="w-3 h-3" />
        Próximamente
        {course.start_date && <span className="ml-1 text-[10px] opacity-80">· {fmtDate(course.start_date)}</span>}
      </Badge>
    );
  }
  if (showActive && (course.start_date || course.end_date)) {
    return (
      <Badge className={`bg-green-100 text-green-700 border border-green-200 gap-1 ${className}`} data-testid={`state-active-${course.id}`}>
        <CheckCircle2 className="w-3 h-3" />
        En curso
      </Badge>
    );
  }
  return null;
};

export default CourseStateBadge;
